import { render, staticRenderFns } from "./CompanyParkList.vue?vue&type=template&id=20bcbdf2&scoped=true&"
import script from "./CompanyParkList.vue?vue&type=script&lang=js&"
export * from "./CompanyParkList.vue?vue&type=script&lang=js&"
import style0 from "./CompanyParkList.vue?vue&type=style&index=0&id=20bcbdf2&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bcbdf2",
  null
  
)

export default component.exports